<div class="request-steps-header">
    <ul>
        <li [ngClass]="{'current': newFeasibilityStatus.step === 1, 'done': newFeasibilityStatus.step > 1 }">
            <span>1</span>
            <p>{{ 'REQUEST_DETAIL.STEPS.ENTER_DATA' | translate }}</p>
        </li>
        <li [ngClass]="{'current': newFeasibilityStatus.step === 2, 'done': newFeasibilityStatus.step > 2 }">
            <span>2</span>
            <p>{{ 'REQUEST_DETAIL.STEPS.FEASIBILITY_RESULT' | translate }}</p>
        </li>
        <li [ngClass]="{'current': newFeasibilityStatus.step === 3, 'done': newFeasibilityStatus.step > 3 }">
            <span>3</span>
            <p>{{ 'REQUEST_DETAIL.STEPS.ACCEPT_DENY' | translate }}</p>
        </li>
    </ul>
</div>

<form [formGroup]="requestDetailFeasibilityService.feasibilityForm" *ngIf="this.newFeasibilityStatus.step === 1">
    <div class="grid viability-form">
        <h2>{{ 'OPEN_BANKING' | translate }}</h2>
        <div class="col-12 grid">
            <label for="IngresosElegibles" class="col-fixed">{{ 'FEASIBILITY_VARIABLES.INGRESOS_ELEGIBLES' | translate }}</label>
            <div class="col">
                <p-inputNumber locale="es-ES" [min]="0" [maxFractionDigits]="2" inputId="IngresosElegibles" formControlName="IngresosElegibles" placeholder="{{ 'COMMON.REQUIRED' | translate }}" />
            </div>
        </div>

        <div class="col-12 grid">
            <label for="GastosComprometidos" class="col-fixed">{{ 'FEASIBILITY_VARIABLES.GASTOS_COMPROMETIDOS' | translate }}</label>
            <div class="col">
                <p-inputNumber locale="es-ES" [min]="0" [maxFractionDigits]="2" inputId="GastosComprometidos" formControlName="GastosComprometidos" placeholder="{{ 'COMMON.REQUIRED' | translate }}" />
            </div>
        </div>

        <div class="col-12 grid">
            <label for="ScoreOpenBanking" class="col-fixed">{{ 'FEASIBILITY_VARIABLES.SCORE_OPEN_BANKING' | translate }}</label>
            <div class="col">
                <p-inputNumber locale="es-ES" [min]="0" [maxFractionDigits]="0" inputId="ScoreOpenBanking" formControlName="ScoreOpenBanking" placeholder="{{ 'COMMON.REQUIRED' | translate }}" />
            </div>
        </div>

        <div class="col-12 grid">
            <label for="IngresosRecurrentesTrimestrales" class="col-fixed">{{ 'FEASIBILITY_VARIABLES.INGRESOS_RECURRENTES_TRIMESTRALES' | translate }}</label>
            <div class="col">
                <p-inputNumber locale="es-ES" [maxFractionDigits]="2" inputId="IngresosRecurrentesTrimestrales" formControlName="IngresosRecurrentesTrimestrales" placeholder="{{ 'COMMON.REQUIRED' | translate }}" />
            </div>
        </div>

        <div class="col-12 grid">
            <label for="ViabilidadOpenBanking" class="col-fixed">{{ 'FEASIBILITY_VARIABLES.FEASIBILITY_OPEN_BANKING' | translate }}</label>
            <div class="ob-buttons-container">
                <p-radioButton inputId="ViabilidadOpenBankingFalse" [value]="false" formControlName="ViabilidadOpenBanking"/>
                <label for="ViabilidadOpenBankingFalse">{{ 'REQUEST_DETAIL.NOT_FEASIBLE' | translate }}</label>
                <p-radioButton inputId="ViabilidadOpenBankingTrue" [value]="true" formControlName="ViabilidadOpenBanking" />
                <label for="ViabilidadOpenBankingTrue">{{ 'REQUEST_DETAIL.FEASIBLE' | translate }}</label>
            </div>
        </div>

        <h2>{{ 'CIRBE' | translate }}</h2>

        <div class="col-12 grid">
            <label for="ImporteDeudaTotalCirculanteCIRBE" class="col-fixed">{{ 'FEASIBILITY_VARIABLES.IMPORTE_DEUDA_TOTAL_CIRCULANTE' | translate }}</label>
            <div class="col">
                <p-inputNumber locale="es-ES" [min]="0" [maxFractionDigits]="2" inputId="ImporteDeudaTotalCirculanteCIRBE" formControlName="ImporteDeudaTotalCirculanteCIRBE" placeholder="{{ 'COMMON.REQUIRED' | translate }}" />
            </div>
        </div>

        <div class="col-12 grid">
            <label for="ImporteMoraCIRBE" class="col-fixed">{{ 'FEASIBILITY_VARIABLES.IMPORTE_MORA_CIRBE' | translate }}
            </label>
            <div class="col">
                <p-inputNumber locale="es-ES" [min]="0" [maxFractionDigits]="2" inputId="ImporteMoraCIRBE" formControlName="ImporteMoraCIRBE" placeholder="{{ 'COMMON.REQUIRED' | translate }}" />
            </div>
        </div>

        <div class="buttons-row">
            <button class="outline-btn" (click)="requestDetailFeasibilityService.resetFeasibility()">
                {{ "REQUEST_DETAIL.RESET" | translate }}
            </button>
            <button class="filled-btn" (click)="submit()" [disabled]="isCalculating">
                @if (isCalculating) {
                    <span class="material-symbols-outlined icon-spin"> refresh </span>
                } @else {
                    <span class="material-symbols-outlined"> checklist </span>
                }
                {{ 'REQUEST_DETAIL.CALCULATE' | translate }}
            </button>
        </div>
    </div>
</form>

<div *ngIf="requestDetailFeasibilityService.isFeasible !== undefined && this.newFeasibilityStatus.step === 2">
    <br>
    <table>
        <thead>
            <tr>
                <th>#</th>
                <th>{{ 'REQUEST_DETAIL.CONCEPT' | translate }}</th>
                <th>{{ 'REQUEST_DETAIL.RULE' | translate }}</th>
                <th class="center">{{ 'REQUEST_DETAIL.STATUS' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let r of requestDetailFeasibilityService.ruleFeasibilityResults; let i = index"
                [ngClass]="{ 'not-feasible': !r.isFeasible, 'feasible': r.isFeasible && !OBRules.includes(r.fieldName) }">
                <td>{{ i + 1 }}</td>
                <td>{{ requestDetailFeasibilityService.translateRuleConcept(r) | async }}</td>
                <td>{{ requestDetailFeasibilityService.translateRuleDescription(r) | async }}</td>
                <td class="center">
                    @if(OBRules.includes(r.fieldName) && r.isFeasible){
                        <span class="material-symbols-outlined"> remove </span>
                    }@else {
                        <span class="line-result" [class.pass]="r.isFeasible">
                            <span class="material-symbols-outlined">
                                {{ r.isFeasible ? 'check_small' : 'exclamation' }}
                            </span>
                        </span>
                    }
                </td>
            </tr>
        </tbody>
    </table>
    <br><br>

    <div class="buttons-row">
        <button class="outline-btn" (click)="goToStepOne()">{{ "NEW_REQUEST.BACK" | translate }}</button>
        <button class="filled-btn" (click)="calculateFreelancerFeasibilityResult()">{{ 'BUTTON.NEXT' | translate }}</button>
    </div>
</div>

<div *ngIf="requestDetailFeasibilityService.isFeasible !== undefined && this.newFeasibilityStatus.step === 3">
    <br>
    <div class="result-box">
        @if (requestDetailFeasibilityService.isFeasible === true) {
            <img src="assets/images/credit-approved.svg" alt="Feasibility > 0" />
            <div>
                <h6>{{ 'REQUEST_DETAIL.FEASIBLE_REQ.TITLE' | translate }}</h6>
                <p>{{ 'REQUEST_DETAIL.FEASIBLE_REQ.DESCRIPTION' | translate }}</p>
                <p [innerHTML]="'REQUEST_DETAIL.ULTIMATE_LIMIT' | translate: { limit: requestDetailFeasibilityService.freelancerFeasibilityResult.ultimateRoundedLimit | number:'1.0-2':'es-ES' }"></p>
            </div>
        } @else {
            <img src="assets/images/credit-denied.svg" alt="Credit denied" />
            <div>
                <h6>{{ 'REQUEST_DETAIL.NOT_FEASIBLT_REQ.TITLE' | translate }}</h6>
                <p>{{ 'REQUEST_DETAIL.NOT_FEASIBLT_REQ.DESCRIPTION' | translate }}</p>
                <p [innerHTML]="'REQUEST_DETAIL.ULTIMATE_LIMIT' | translate: { limit: 0 }"></p>
            </div>
        }
    </div>

    <div class="buttons-row">
        <button class="outline-btn" (click)="goToStepTwo()">{{ "NEW_REQUEST.BACK" | translate }}</button>
        <button class="filled-btn" (click)="completeOperation()">{{ 'BUTTON.NEXT' | translate }}</button>
    </div>
</div>
